import { UserModel } from "../../user/_models/user.model";

export class SpaceModel {
  id: number;
  name: string;
  number_space: string;
  description: string;
  active: string;
  functionary: any;
  functionarys: any[];
}
